import { useSelector } from 'react-redux';

import * as contractingSelectors from '@makemydeal/dr-dash-store/selectors/contractingSelectors';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';

import { useIsDealLocked } from './useDealLockStatus';

export type SwapUnavailableCode = 'DEAL_LOCKED' | 'CONTRACT_GENERATED' | 'BUSINESS_PARTICIPANT';

export type SwapAvailability =
    | { isDisabled: false; code?: undefined; reason?: undefined }
    | { isDisabled: true; code: SwapUnavailableCode; reason: string };

export const SWAP_UNAVAILABLE_REASONS: Record<SwapUnavailableCode, string> = {
    DEAL_LOCKED: 'This deal is finalized, so the buyer and co-buyer cannot be swapped.',
    CONTRACT_GENERATED: 'Not available after contracts are generated.',
    BUSINESS_PARTICIPANT: 'Deals with a business customer cannot have the buyer and co-buyer swapped.'
};

export const useSwapAvailability = (): SwapAvailability => {
    const isLocked = useIsDealLocked();
    const isContractGenerated = useSelector(contractingSelectors.getIsContractGenerated);
    const isBusinessBuyer = useSelector(offerSelectors.getIsBusinessShopper);
    const isBusinessCoBuyer = useSelector(offerSelectors.getIsBusinessCoBuyer);

    if (isLocked) {
        return { isDisabled: true, code: 'DEAL_LOCKED', reason: SWAP_UNAVAILABLE_REASONS.DEAL_LOCKED };
    }

    if (isContractGenerated) {
        return { isDisabled: true, code: 'CONTRACT_GENERATED', reason: SWAP_UNAVAILABLE_REASONS.CONTRACT_GENERATED };
    }

    if (isBusinessBuyer || isBusinessCoBuyer) {
        return { isDisabled: true, code: 'BUSINESS_PARTICIPANT', reason: SWAP_UNAVAILABLE_REASONS.BUSINESS_PARTICIPANT };
    }

    return { isDisabled: false };
};
